"use client";

import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { getQueryClient } from "@/lib/getQueryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactNode } from "react";

//#region [Props]
type QueryClientWrapperProps = {
    children: ReactNode;
}
//#endregion

//#region [Component]
export default function QueryWrapper({ children }: QueryClientWrapperProps) {
    const queryClient = getQueryClient();
    return (<QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools />
    </QueryClientProvider>);
}
//#endregion

//#region [Styles]

//#endregion